import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { readyToBuyPieces } from '../utils/mockData';
import { useContent, resolveAsset } from '../contexts/ContentContext';
import ProductGrid from '../components/ProductGrid';
import SEO from '../components/SEO';

const mapDb = (p) => ({
  id: p.id,
  type: p.type,
  name: p.name,
  description: p.description,
  technique: p.embroidery || 'Bespoke',
  material: p.fabric || 'Pure Silk',
  price: p.price,
  image: resolveAsset(p.image),
});

const ShopPage = () => {
  const { products } = useContent();
  const dbItems = products.filter((p) => p.type === 'ready-to-wear' && p.price != null).map(mapDb);
  const items = dbItems.length ? dbItems : readyToBuyPieces;

  return (
    <section style={styles.page} data-testid="shop-page">
      <SEO
        title="Shop the Atelier — Ready to Wear"
        description="Heirloom-grade silk blouses, lehengas, kurta sets and dupattas \u2014 hand-finished in Lucknow and ready to ship worldwide."
        path="/shop"
      />
      <div className="luxury-container">
        <Link to="/" style={styles.back} data-testid="shop-back">
          <ArrowLeft size={18} />
          <span>Back to Home</span>
        </Link>

        <header style={styles.header}>
          <p style={styles.eyebrow}>Ready to Wear</p>
          <h1 className="heading-1" style={styles.title}>Shop the Atelier</h1>
          <p style={styles.lead}>
            Hand-finished pieces, available now. Every order is dispatched with our
            signature heritage packaging from Lucknow.
          </p>
        </header>

        <ProductGrid
          items={items}
          variant="ready"
          testIdPrefix="shop"
        />
      </div>
    </section>
  );
};

const styles = {
  page: {
    padding: '140px 0 100px',
    backgroundColor: 'var(--bg-primary)',
    minHeight: '100vh',
  },
  back: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    textDecoration: 'none',
    fontFamily: "'Inter', sans-serif",
    fontSize: '12px',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginBottom: '40px',
  },
  header: {
    textAlign: 'center',
    maxWidth: '640px',
    margin: '0 auto 72px',
  },
  eyebrow: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '16px',
  },
  title: {
    marginBottom: '20px',
  },
  lead: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '16px',
    lineHeight: '1.8',
    color: 'var(--text-secondary)',
  },
};

export default ShopPage;
